import { render, staticRenderFns } from "./deLiveryPoint.vue?vue&type=template&id=6b0db924&scoped=true"
import script from "./deLiveryPoint.vue?vue&type=script&lang=js"
export * from "./deLiveryPoint.vue?vue&type=script&lang=js"
import style0 from "./deLiveryPoint.vue?vue&type=style&index=0&id=6b0db924&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0db924",
  null
  
)

export default component.exports